import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function useFilters (initialFilters?: Filter[]) {
  const [filters, setFilters] = useState<Filter[]>(initialFilters || [])
  const { t } = useTranslation()

  const addFilter = (newFilter: Filter) => {
    const updatedFilters = filters.map(filter =>
      filter.name === newFilter.name ? { ...filter, ...newFilter } : filter
    )
    if (!updatedFilters.some(filter => filter.name === newFilter.name)) {
      updatedFilters.push(newFilter)
    }
    setFilters(updatedFilters)
  }

  const removeFilter = (name: string) => {
    const updatedFilters = filters.map(filter =>
      filter.name === name ? { ...filter, value: undefined, valueLabel: t('All') } : filter
    )
    setFilters(updatedFilters)
  }

  const clearFilters = () => {
    const updatedFilters = filters.map(filter => ({
      ...filter,
      value: undefined,
      valueLabel: t('All')
    }))
    setFilters(updatedFilters)
  }

  return { filters, addFilter, removeFilter, clearFilters }
}

type Filter = {
  name: string
  value: string | number | undefined
  valueLabel: string
}
